import React from 'react';
import { Icon as EcoIcon } from "@bsw/react-nightingale";

export const Icon = (props) => {
    return <EcoIcon {...props}/>
}

export default Icon;
